import React, { useState, useEffect, } from "react";
import { CSVLink } from "react-csv";
import { useNavigate, Link, useParams } from 'react-router-dom';
import db from "./Firebase";
import Moment from "moment";
import { extendMoment } from "moment-range";

function LoanRemarks() {
    const moment = extendMoment(Moment);
    const [remarksData, setRemarksData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [searchQuery, setSearchQuery] = useState(""); // New state for search input

    useEffect(() => {
        const fetchRemarks = async () => {
            try {
                const snapshot = await db.collection("loan_extra_data").get();
                const allRemarks = [];

                snapshot.forEach((doc) => {
                    const data = doc.data();
                    const email = data.email || "N/A";
                    const phone = data.phone || "N/A";

                    if (Array.isArray(data.remark)) {
                        data.remark.forEach((remarkItem) => {
                            allRemarks.push({
                                email: remarkItem.email || "N/A",
                                phone,
                                title: remarkItem.title || "N/A",
                                text: remarkItem.text || "N/A",
                                updated_date: remarkItem.updated_date
                                    ? moment(remarkItem.updated_date.toDate()).format("MM/DD/YY, h:mm a")
                                    : "N/A",
                            });
                        });
                    }
                });

                setRemarksData(allRemarks);
                setFilteredData(allRemarks); // Initialize with full data
                setLoading(false);
            } catch (error) {
                console.error("Error fetching remarks:", error);
                setLoading(false);
            }
        };

        fetchRemarks();
    }, []);


    // Handle search by phone number
    const handleSearch = (event) => {
        const query = event.target.value;
        setSearchQuery(query);

        if (!query) {
            setFilteredData(remarksData);
        } else {
            const filtered = remarksData.filter((remark) =>
                remark.phone.includes(query)
            );
            setFilteredData(filtered);
        }
    };

    const headers = [
        { label: "Email", key: "email" },
        { label: "Phone", key: "phone" },
        { label: "Title", key: "title" },
        { label: "Text", key: "text" },
        { label: "Updated Date", key: "updated_date" },
    ];

    return (
        <main class="main-content position-relative max-height-vh-100 h-100 border-radius-lg">
            <div class="p-2" style={{ paddingBottom: "5px", display: "flex", justifyContent: "space-between" }}>
                <Link to="/">
                    <img src="/images/menubutton.png" class="menu-toggle" alt="Responsive image" style={{ height: "2rem" }} />
                </Link>
                <CSVLink data={remarksData} headers={headers} filename="loan_remarks.csv" className="btn btn-primary">
                    Download All Remarks
                </CSVLink>
            </div>

            <div class="">
                <div class="p-2">
                    <div style={{ textAlign: "end", paddingBottom: "5px" }}>
                    </div>
                    <div class="card">
                        <div class="card-header pb-0 px-3">
                            <h6 class="mb-2">Loan Remarks</h6>
                        </div>
                        <input
                            type="text"
                            className="form-control mb-3"
                            placeholder="Search by Phone Number"
                            value={searchQuery}
                            onChange={handleSearch}
                            style={{ maxWidth: "300px" }}
                        />
                        <div class="">
                            <div class="card">
                                <div class="table-responsive fix-width scroll-inner">
                                    <table class="table table-bordered table-hover">
                                        <thead class="thead-dark" style={{ position: "sticky", top: "0" }}>
                                            <tr>
                                                <th>#</th>
                                                <th>Email</th>
                                                <th>Phone</th>
                                                <th>Title</th>
                                                <th style={{ maxWidth: "500px", wordWrap: "break-word", whiteSpace: "pre-wrap" }}>Remarks</th>
                                                <th>Updated Date</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {filteredData.map((remark, index) => (
                                                <tr key={index}>
                                                    <td>{index + 1}</td>
                                                    <td>{remark.email}</td>
                                                    <td>{remark.phone}</td>
                                                    <td>{remark.title}</td>
                                                    <td style={{ maxWidth: "500px", wordWrap: "break-word", whiteSpace: "pre-wrap" }}>
                                                        {remark.text}
                                                    </td>
                                                    <td>{remark.updated_date}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>

    );
}

export default LoanRemarks;
